import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
// import { DialogComponent } from '@syncfusion/ej2-react-popups';
import logout from '../login/Logout';
import { tokenVerification } from './Utils';
class ProviderInfo extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
                showPwd: false,
                showCPwd: false,
                showOldPwd: false,
            });
        };
        this.DeletedialogClose = () => {
            this.setState({ hideTextAreaPopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteStaffDetail(this.state.propsId)
                this.setState({ disabled: false })

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchStaffDetails()
                this.setState({ disabled: false })
            }
        }];

        const date = new Date();
        var minute = date.getMinutes();
        if (date.getMinutes() > 0 && date.getMinutes() < 10) {
            minute = '0' + date.getMinutes();
        }
        const showCurrentTime = date.getHours()
            + ':' + minute;

        this.state = {
            hiddenUserId: '',
            errors: {},
            showModel: false,
            user_editable: false,
            error: '',
            healthSystemId: '',
            hospitalId: '',
            serviceLineId: '',
            procedureDropDownValue: '',
            physicianId: '',
            selectedDate: new Date(),
            showEditBtn: false,
            patientName: '',
            patientEmailId: '',
            patientContactNumber: '',
            value: [],
            data: [{
                id: '',
                name: '',
                phoneNumber: '',
                emailId: ''
            }],
            disabled: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            successResp: false,
            pageNum: null,
            userRoleId: '',
            startTime: showCurrentTime
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;

        setTimeout(() => {
            thisController.fetchPhysicianDetails();
            // thisController.fetchUserDetails();
        }, 300);


    }

    fetchPhysicianDetails() {
        var fetchController = this;

        $.ajax({
            url: "/my-jeeva-api/fetch-my-info",

            method: 'GET',
            data: {
                userEmailId: JSON.parse(localStorage.getItem("user_details"))["emailId"]
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var responseData = res.result;
                    fetchController.state.user_editable = false;
                    if (responseData.length != 0) {
                        document.getElementById('user_name').value = responseData.userName;
                        document.getElementById('designation').value = responseData.designation;
                        document.getElementById('contact_number').value = responseData.userPhoneNumber;
                        document.getElementById('email').value = responseData.userEmailId;
                        // document.getElementById('comments').value = responseData.comments;
                        fetchController.state.hiddenUserId = responseData.id;
                        fetchController.setState(fetchController.state);
                    }

                }
                else {
                    fetchController.NotifyFailToLoad();
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                   tokenVerification();
                }
            }
        });
    }
    validateForm = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("oldPassword").value) {
            errors["oldPassword"] = "*Please enter your old password";
        }

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    changePasswordApi = (e) => {
        let errors = {};
        var newPassword = document.getElementById("newPassword").value;
        var confirmPassword = document.getElementById("confirmPassword").value;

        if (document.getElementById("oldPassword").value == "") {
            errors["oldPassword"] = "*Please enter your old password";
            this.setState({errors: errors});
        } else if (newPassword == "" || (!newPassword.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/))) {
            errors["newPassword"] = "*Please enter secure and strong password.";
            this.setState({errors: errors});
        } else if (newPassword.length < 8) {
            errors["newPassword"] = "*Please enter atleast 8 characters";
            this.setState({errors: errors});
        } else if (newPassword != confirmPassword) {
            errors["confirmPassword"] = "*Passwords don't match";
            this.setState({errors: errors});
        } else {
            e.preventDefault();
            if (this.validateForm()) {
                let myAccountController = this;

                let data = {
                    "emailId": JSON.parse(localStorage.getItem("user_details"))["emailId"],
                    "oldPassword": document.getElementById("oldPassword").value,
                    "newPassword": document.getElementById("newPassword").value
                }
                myAccountController.myFormRef.reset();
                $.ajax({
                    url: "/my-jeeva-api/change-password",

                    type: 'POST',
                    headers: {
                        "Authorization": "Bearer " + localStorage.getItem("access_token"),
                        "Content-Type": "application/json"
                    },

                    data: JSON.stringify(data),
                    success: function (res) {
                        if (res.success === true) {
                            myAccountController.setState({ showStore: false });
                            myAccountController.notifyPasswordChanged();
                            setTimeout(() => {
                                logout();
                            }, 300);

                        } else {
                            myAccountController.setState({ disableOtp: true });
                            errors["response"] = res.result;
                            myAccountController.setState({
                                errors: errors
                            });
                        }
                    }
                });
            }
        }
    }

    notifyUpdateToast() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;Profile is updated Successfully
        </b>, {
            position: "top-center",
        });
    }

    updateUserApi = () => {

        var updatedDataController = this;

        var adminName = document.getElementById("user_name").value.trim();
        var adminContactNumber = document.getElementById("contact_number").value.trim();
        var adminEmailId = document.getElementById("email").value.trim();
        var designation = document.getElementById("designation").value.trim();
        // var comment = document.getElementById('comments').value.trim();
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        var contactNumberPattern = new RegExp(/^(?=.*\d).+$/);

        if (adminName == "" || adminContactNumber == "" || adminEmailId == "" || designation == "" ) {
            updatedDataController.notifyMsgFieldEmpty();
        } else if(!namePattern.test(adminName)){
            updatedDataController.notifyImproperName();
        }
        else if (!pattern.test(adminEmailId)) {
            updatedDataController.notifyImproperEmailId();
        }
        else if (!contactNumberPattern.test(adminContactNumber)) {
            updatedDataController.notifyImproperContactNumber();
        } else {
            var saveData = {
                // healthSystemId: JSON.parse(localStorage.getItem("user_details"))["healthSystemId"],
                id: updatedDataController.state.hiddenUserId,
                userEmailId: adminEmailId,
                userName: adminName,
                userPhoneNumber: adminContactNumber,
                designation: designation,
                // comments: comment
            }
            $.ajax({
                url: "/my-jeeva-api/update-provider-acc-info",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {

                    if (res.success === true) {
                        updatedDataController.notifyUpdateToast();
                        updatedDataController.state.user_editable = true;
                        updatedDataController.fetchPhysicianDetails();
                    } else {
                        if (res.result != "") {
                            updatedDataController.notifyFailedToUpdate(res.result);
                            updatedDataController.state.user_editable = false;
                        }
                        else {
                            updatedDataController.notifyFailedToUpdate(res.result);
                            updatedDataController.state.user_editable = false;
                        }
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }

    }
    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }
    notifyImproperEmailId() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid email id</b>, {
            position: "top-center"
        });

    }
    notifyImproperContactNumber() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid contact number</b>, {
            position: "top-center"
        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b><img src="/my-jeeva/assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    notifyPasswordChanged() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Hurray! Your Password Changed Successfully</b>, {
            position: "top-center",

        });

    }


    handleChangeName = (e) => {
        this.state.patientEmailId = e.target.value;
        this.setState(this.state);

    }

    handleChangeDescription = (e) => {
        this.state.patientName = e.target.value;
        this.setState(this.state);
    }
    editValue = () => {
        this.state.user_editable = true;
        this.setState(this.state);
    }
    editUserValue = () => {
        this.state.user_editable = true;
        this.setState(this.state);
    }
    refreshData = () => {
        var thisController = this;
        thisController.fetchPhysicianDetails();
    }
    showChangePwd = () => {
        this.setState({ showOldPwd: false })
        this.setState({ showModel: true });
    }
    closeChangePwd = () => {
        this.setState({
            errors: {},
            showOldPwd: false,
            showPwd: false,
            showCPwd: false,
            showModel: false
        });
        {
            this.myFormRef.reset();
        }
    }
    validateNewPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("newPassword").value) {
            formIsValid = false;
            errors["newPassword"] = "*Please enter your new password";
        }

        if (typeof document.getElementById("newPassword").value !== "undefined") {
            if (!document.getElementById("newPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["newPassword"] = "*Please enter secure and strong password.";
            }
        }
        var newPassword = document.getElementById("newPassword").value
        if(newPassword.length < 8){
            formIsValid = false;
                errors["newPassword"] = "*Please enter atleast 8  characters.";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateConfirmPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Please enter the new password to confirm";
        }

        if (typeof document.getElementById("confirmPassword").value !== "undefined") {
            if (!document.getElementById("confirmPassword").value.match(/(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d](?=.*[ !"#$%&'()*+,-./:;<=>?@[\]\\^_`{|}~]){8,30}/)) {
                formIsValid = false;
                errors["confirmPassword"] = "*Please enter secure and strong password.";
            }
        }

        if (document.getElementById("newPassword").value !== document.getElementById("confirmPassword").value) {
            formIsValid = false;
            errors["confirmPassword"] = "*Passwords don't match";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }

    validateOldPwd = () => {
        let errors = {};
        let formIsValid = true;

        if (!document.getElementById("oldPassword").value) {
            formIsValid = false;
            errors["oldPassword"] = "*Please enter your old password";
        }

        this.setState({
            errors: errors
        });
        return formIsValid;
    }
    saveProfileUpdatedInfo() {
        //TO DO
    }

    showOldPassword = () => {
        if (this.state.showOldPwd) {
            this.setState({ showOldPwd: false });
        } else {
            this.setState({ showOldPwd: true });
        }
    }

    showPassword = () => {
        if (this.state.showPwd) {
            this.setState({ showPwd: false });
        } else {
            this.setState({ showPwd: true });
        }
    }

    showConfirmPassword = () => {
        if (this.state.showCPwd) {
            this.setState({ showCPwd: false });
        } else {
            this.setState({ showCPwd: true });
        }
    }

    oldPasswordResetInput = () => {
        document.getElementById('oldPassword').value = '';
    }

    newPasswordResetInput = () => {
        document.getElementById('newPassword').value = '';
    }

    confirmPasswordResetInput = () => {
        document.getElementById('confirmPassword').value = '';
    }


    render() {
        return (
            <div id="providerInfo" style={{ height: '430px' }}>
                <div className="content" style={{ backgroundColor: "#F9F9FB", marginLeft: '-10px' }}>
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <ToastContainer className="Toast-at-center" />

                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <title> Dheeyantra | Clusters Details</title>
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <div className="row">
                        <div className="col-sm-6">
                            <h6 className="nav-item" style={{
                                color: '#282a65',
                                marginTop: '24px', marginLeft: '1vw'
                            }}>My Information</h6>
                        </div>
                        {/* Add button and refresh button*/}
                        <div className="col-sm-6" Align='right'>
                        <button type="button" className="btn action-button"
                                                style={{ 
                                                width: "150px", 
                                                fontSize: '14px', 
                                                // marginTop: '3vw'
                                                 }} onClick={this.showChangePwd}>Change Password</button>

                            <button className="btn action-button " style={{ marginLeft: '13px' }}
                                title={this.state.user_editable ? "Save" : "Edit"} 
                                id="addMsg"
                                onClick={this.state.user_editable ? this.updateUserApi : this.editUserValue}
                            ><img src={this.state.user_editable ? this.saveImageSrc : this.editImageSrc} />
                            </button>
                            <button onClick={this.refreshData} className="btn action-button" title="Refresh" >
                                <img src="./assets/images/refresh_white_24dp.png"></img>
                            </button>
                        </div>

                    </div>
                    <div className="card-body p-0 mb-25" style={{ display: ((window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.PHYSICIAN) || (window.SCOPE_VALUE.CURRENT == window.SCOPE_VALUE.NURSE)) ? 'block' : 'none', marginLeft: '1vw' }}>
                        <div className="tab-content col-12 p-0">
                            <div className="card card-primary mt-3" style={{ height: '80%' }}>
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">

                                    <div className="col-sm-12" >
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Name:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="user_name" placeholder="Enter Name"
                                                    disabled={!this.state.user_editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.user_editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Position:</div>
                                                <input className="col-sm-8"
                                                    type="text" id="designation"
                                                    name="designation" placeholder="Enter Position"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={!this.state.user_editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.user_editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-sm-12" >
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Contact Number:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="contact_number" placeholder="Enter Contact Number"
                                                    disabled={!this.state.user_editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.user_editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Email:</div>
                                                <input className="col-sm-8"
                                                    type="text" id="email"
                                                    name="email" placeholder="Enter Email"
                                                    //value={this.state.fields.supportEmail}
                                                    disabled={true}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: "1px solid #ffffff"
                                                    }} />
                                            </div>

                                        </div>
                                    </div>
                                    <div className="col-sm-12" >
                                        <div className="col-sm-6">
                                            {/* <div className="row" style={{ marginTop: '20px' , display:"flex", alignContent:"center"}}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Comments :</div>
                                                <textarea className="form-control raise-form-input" style={{ width: '30vw', height:"18vh" ,border: 'none' }}
                                                    rows="1" placeholder="Enter Comments"
                                                    id="comments" name="name"
                                                    disabled={!this.state.user_editable}
                                                    // value={this.state.rows[idx].sluDescription}
                                                    onChange={this.handleChange}
                                                ></textarea>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="comments" placeholder="Enter Comments"
                                                    disabled={!this.state.user_editable}
                                                    //value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.user_editable ? "1px solid #ffffff" : '1px solid #b2b2b2',
                                                        overflowY: 'scroll'
                                                    }} />
                                            </div> */}
                                        </div>
                                    </div>
                                    {/* <div className='row' style={{ height: '10vw' }}>
                                        <div className='col-sm-6'>
                                            <button type="button" className="btn btn-primary"
                                                style={{ width: "150px", fontSize: '14px', marginTop: '3vw' }} onClick={this.showChangePwd}>Change Password</button>

                                        </div>
                                        <div className='col-sm-6'>

                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="wrapper">
                        <div className="modal" style={{ display: this.state.showModel ? 'block' : 'none' }}>
                            <div className="modal-dialog" id="center-aligned-password-modal">
                                <div className="modal-content" style={{ height: "auto", width: "830px" }}>
                                    <div className="modal-header noBorder" style={{ height: '39px' }}>
                                        <div className="errorMsg" style={{ color: 'red' }} name="response">{this.state.errors.response}</div>
                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={this.closeChangePwd}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>
                                    </div>
                                    <div className="modal-body">
                                        <form ref={(el) => this.myFormRef = el}>
                                            {/* <div className="form-group row"> */}
                                            <div className="input-group mb-3">
                                                <label className="col-sm-3 col-form-label">Old Password</label>
                                                <div className="col-sm-9">
                                                    <input type={this.state.showOldPwd ? "text" : "password"} className="form-control sign-in- passinput" name="oldPassword"
                                                        style={{ width: '92%' }}
                                                        id="oldPassword" onBlur={this.validateOldPwd}
                                                        value={this.state.password} onChange={this.handleChange} placeholder="Enter old password" aria-label="Dhee password"
                                                        onKeyDown={this.handleKeyDown} />
                                                    <button className="btn showPassbtn" type="button" onClick={this.showOldPassword}>{this.state.showOldPwd ? 'Hide' : 'Show'}</button>
                                                    <button className="btn showPassbtn" type="button" onClick={this.oldPasswordResetInput} id='resetInput'>Reset</button>
                                                </div>
                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.oldPassword}</div>
                                            </div><br />


                                            <div className="input-group mb-3" style={{ marginTop: '15px' }}>
                                                <label className="col-sm-3 col-form-label">New Password</label>
                                                <div className="col-sm-9">
                                                    <input type={this.state.showPwd ? "text" : "password"} className="form-control sign-in- passinput" name="password"
                                                        style={{ width: '92%' }}
                                                        id="newPassword" onBlur={this.validateNewPwd}
                                                        value={this.state.password} onChange={this.handleChange} placeholder="Enter new password" aria-label="Dhee password"
                                                        onKeyDown={this.handleKeyDown} />
                                                    <button className="btn showPassbtn" type="button" onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                                                    <button className="btn showPassbtn" type="button" onClick={this.newPasswordResetInput} id='resetInput'>Reset</button>
                                                </div>
                                                <span className="pNote" style={{ marginLeft: '1vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.newPassword}</div>
                                            </div>

                                            <div className="input-group mb-3" style={{ marginTop: '30px' }}>
                                                <label className="col-sm-3 col-form-label">Confirm Password</label>
                                                <div className="col-sm-9">
                                                    <input type={this.state.showCPwd ? "text" : "password"} className="form-control sign-in- passinput" name="confirmPassword"
                                                        style={{ width: '92%' }}
                                                        id="confirmPassword" onBlur={this.validateConfirmPwd}
                                                        value={this.state.password} onChange={this.handleChange} placeholder="Enter confirm password" aria-label="Dhee password"
                                                        onKeyDown={this.handleKeyDown} />
                                                    <button className="btn showPassbtn" type="button" onClick={this.showConfirmPassword}>{this.state.showCPwd ? 'Hide' : 'Show'}</button>
                                                    <button className="btn showPassbtn" type="button" onClick={this.confirmPasswordResetInput} id='resetInput'>Reset</button>
                                                </div><br />
                                                <span className="pNote" style={{ marginLeft: '1vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                <div className="errorMsg" style={{ color: 'red', marginTop: "-6.5rem" }}>{this.state.errors.confirmPassword}</div>
                                            </div>

                                            {/* <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">New Password</label>
                                                <div className="col-sm-6">
                                                    <input style={{ width: '92%' }}
                                                        type={this.state.showPwd ? "text" : "password"}
                                                        className="form-control-plaintext"
                                                        onBlur={this.validateNewPwd}
                                                        name="newPassword" id="newPassword" onChange={this.handleChange} />
                                                </div>
                                                <div className='col-sm-3'>
                                                    <div className="input-group-append">
                                                        <button className="btn" type="button"
                                                            onClick={this.showPassword}>{this.state.showPwd ? 'Hide' : 'Show'}</button>
                                                    </div>
                                                </div>

                                            </div> */}
                                            <br />

                                            {/* <div className="form-group row">
                                                <label className="col-sm-3 col-form-label">Confirm Password</label>
                                                <div className="col-sm-6">
                                                    <input style={{ width: '92%' }} type={this.state.showCPwd ? "text" : "password"} className="form-control-plaintext" onBlur={this.validateConfirmPwd}
                                                        name="confirmPassword" id="confirmPassword" onChange={this.handleChange} />
                                                </div>
                                                <div className='col-sm-3'>
                                                    <div className="input-group-append">
                                                        <button className="btn" type="button"
                                                            onClick={this.showConfirmPassword}>{this.state.showCPwd ? 'Hide' : 'Show'}</button>
                                                    </div>
                                                </div>
                                                <span className="pNote" style={{ marginLeft: '15vw' }}>Minimum 8 Characters, atleast 1 number, 1 capital letter, 1 small letter and 1 special character</span>
                                                <div className="errorMsg" style={{ color: 'red' }}>{this.state.errors.confirmPassword}</div>

                                            </div><br /> */}

                                            <div className="modal-footer noBorder">
                                                <button type="button" className="btn btn-primary navyblue-btn mx-auto" data-dismiss="modal" onClick={this.changePasswordApi}>Done</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div >
                    {/* <DialogComponent width='400px' style={{}} animationSettings={this.settings}
                        header='Basic App Details' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog} target='#providerInfo'
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete basic app details?<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent> */}

                </div>

            </div>

        );
    }
}
export default ProviderInfo;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ProviderInfo.js